import {Inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CanActivate} from '@angular/router';
import {AccountInfo} from '@azure/msal-common';
import {
  MsalService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration
} from '@azure/msal-angular';
import {Subscription} from 'rxjs';
import {AccountService} from './account.service';
import {InternalMsgService} from './internal.msg.service';
import {environment} from '../../environments/environment';


interface Account extends AccountInfo {
  idTokenClaims?: {
    preferred_username?: string,
    family_name?: string,
    given_name?: string,
    groups?: string[],
    _claim_names?: {
      groups: string | string[]
    },
    _claim_sources?: {
      src1: {
        endpoint: string | string[]
      }
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class GroupGuardService implements CanActivate {
  msgSubscr!: Subscription;

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
              private authService: MsalService,
              private msgService: InternalMsgService,
              private router: Router,
              private accountService: AccountService) {
  }

  canActivate(): boolean {
    const account: Account = this.authService.instance.getAllAccounts()[0];
    if (!account) {
      return false;
    }

    this.msgSubscr = this.msgService.loggedInAccountSet$.subscribe(account => {

      if (account) {
        if (account.email == "" && this.accountService.isAccessDenied()) {
          this.router.navigate([`/accessdenied`]);
        }
        if (account.email == "" && this.accountService.isNonAccessRelatedFail()) {
          this.router.navigate([`/error`]);
        }
      }

      if (account?.email.trim() == "") {
        this.router.navigate([`/accessdenied`]);
      }
    });

    this.accountService.fetchAccount();

    if (this.accountService.getAccount().email.trim() == "") {
      return false;
    }

    if (account.idTokenClaims?.groups?.includes(environment.entraGroup)) {
      return true;
    }

    return environment.url === 'str.scania.com';
  }
}
